module.exports = {
  listingid: undefined,
  medium: [{
    "embedded": null,
    "file_name": null,
    "gallery_uuid": "",
    "gallery_category_uuid": "",
    "caption": "",
    "description": "",
    "urls": [{
      "full_url": "",
      "gallery_url": "",
      "thumb_url": "",
    }],
    "title": null,
    "small_url": "",
    "raw_url": "",
    "height": null,
    "width": null,
    "mime_type": "",
    "carousel_autoplay_timeout": 1000,
  }]
}



// WEBPACK FOOTER //
// ./src/data/store.js